import * as React from 'react';
import clsx from 'clsx';
import './chip.scss';

interface ChipProps {
  label: string;
  className?: string;
  size?: 'small' | 'medium';
  selected?: boolean;
  disabled?: boolean;
  closable?: boolean;
  leftIcon?: React.ReactNode;
  leftIconSize?: 8 | 16 | 24 | 32;
  rightIcon?: React.ReactNode;
  rightIconSize?: 8 | 16 | 24 | 32;
  onClick?: (label: string) => void;
  onClose?: () => void;
  styles?: React.CSSProperties;
  labelColor?: string;
  value?: string;
}

function Chip(props: ChipProps) {
  const {
    label,
    value,
    leftIcon,
    rightIcon,
    onClose,
    onClick,
    styles,
    size = 'medium',
    selected = false,
    className,
    disabled = false,
    leftIconSize = 16,
    rightIconSize = 16,
    closable = false,
    labelColor = 'black',
  } = props;
  const sizeCls = size === 'medium' ? 'c-chip--choice' : `c-chip--choice-${size}`;
  const selectedCls = selected ? 'c-chip--active' : '';
  const [visible, setVisible] = React.useState(true);

  const customIcon = (icon, iconSize) => {
    if (!icon) return;
    if (React.isValidElement(icon)) {
      return React.cloneElement(icon, { style: { fontSize: iconSize } } as React.HTMLAttributes<HTMLElement>);
    }
    const iconCls = `icon-${iconSize}-${icon} c-chip__icon-padding`;
    return <span className={iconCls} />;
  };

  const closeChip = () => {
    onClose && onClose();
    setVisible(false);
  };

  const clickChip = () => {
    onClick && onClick(value);
  };

  return (
    <>
      {visible && (
        <div className="chip-wrapper">
          {React.cloneElement(
            <div className={clsx('c-chip', sizeCls, className, selectedCls)} onClick={() => clickChip()} style={styles}>
              {customIcon(leftIcon, leftIconSize)}
              <span className="c-chip__text" style={{ color: labelColor }}>
                {label}
              </span>
              {closable && (
                <span className="c-chip__close" onClick={() => closeChip()}>
                  ✕
                </span>
              )}
              {customIcon(rightIcon, rightIconSize)}
            </div>,
            { disabled }
          )}
        </div>
      )}
    </>
  );
}

export { Chip };
